(() => {
  const discountEachCents = (quantity) => {
    const count = Math.max(0, Number.parseInt(quantity, 10) || 0);
    if (count >= 4) return 9000;
    if (count >= 2) return 2000;
    return 0;
  };

  const calculateOrder = ({
    standardQty = 0,
    bundleQty = 0,
    standardPriceCents = 0,
    bundlePriceCents = 0,
    standardComparePriceCents = standardPriceCents,
    bundleComparePriceCents = bundlePriceCents
  } = {}) => {
    const standard = Math.max(0, Number.parseInt(standardQty, 10) || 0);
    const bundle = Math.max(0, Number.parseInt(bundleQty, 10) || 0);
    const quantity = standard + bundle;
    const discount = discountEachCents(quantity);
    const subtotalCents = standard * Number(standardPriceCents || 0)
      + bundle * Number(bundlePriceCents || 0);
    const compareSubtotalCents = standard * Math.max(
      Number(standardComparePriceCents || 0),
      Number(standardPriceCents || 0)
    ) + bundle * Math.max(
      Number(bundleComparePriceCents || 0),
      Number(bundlePriceCents || 0)
    );
    const additionalSavingsCents = quantity * discount;
    const savingsCents = Math.max(0, compareSubtotalCents - subtotalCents) + additionalSavingsCents;

    return {
      quantity,
      discountEachCents: discount,
      subtotalCents,
      savingsCents,
      totalCents: Math.max(0, subtotalCents - additionalSavingsCents)
    };
  };

  const savingsBadgeCopy = (savingsCents) => ({
    label: "SAVE",
    amount: new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0
    }).format(Math.max(0, Number(savingsCents || 0)) / 100)
  });

  const defaultOrderQuantities = () => ({ standard: 1, bundle: 1 });

  const api = { discountEachCents, calculateOrder, savingsBadgeCopy, defaultOrderQuantities };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  if (typeof window !== "undefined") window.UT2PricingRules = api;
})();
